import React from "react";
export const MembersIcon = () => (
  <svg
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 10.5C17 6.94792 10.4344 6.99244 9.74414 8.7181L10.6645 9.35723L11.5 10.4997C17 10.4997 16 10.4999 17 10.5Z"
      stroke="#A8A8A8"
    />
    <circle cx="13.0904" cy="4.26671" r="1.98888" stroke="#A8A8A8" />
    <circle
      cx="6.48813"
      cy="3.33969"
      r="2.81444"
      stroke="black"
      strokeWidth="1.0505"
    />
    <path
      d="M1 11.5C1 6.53225 11.7423 6.7898 11.7423 11.5562L1 11.5Z"
      stroke="black"
      strokeWidth="1.0505"
    />
  </svg>
);
